import React from "react";
import "./css/error.css";
import errorImg from "./css/img/svg404.webp";

const Error = () => {
  return (
    <div className="error-container">
      <div className="error-content">
        <img
          src={errorImg}
          alt="404 - Page not found"
          className="error-image"
        />

        <h2>Page Not Found</h2>
        <p>The page you are looking for doesn't exist or has been moved.</p>
      </div>
    </div>
  );
};

export default Error;
